import React, { useState, useEffect } from "react";
import { Text, StyleSheet, View, Platform } from "react-native";

import cardStyles from "./cardStyles";
import AppTheme from "../../AppTheme";
import moment from "moment";

import CloseIcon from "../../common/dialog/CloseIcon";
import ManaButton from "../../common/ManaButton";
import ReportsIcon from "../../common/icons/more/ReportsIcon";
import { navigate } from "../../../../helpers/utils";
import CardUtils from "./CardUtils";
import appPages from "../../../../appPages";

export default function NewReportsCard({
  controller,
  data = {},
  isSnoozed = false,
}) {
  const [showCard, setShowCard] = useState(true);

  const cardUtils = new CardUtils(controller, data, setShowCard);
  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  const createReport = (reportDate, timeUnit) => {
    //navigate(controller, "sets_reflection");
    navigate(controller, appPages.reportsPage, "changepage", {
      args: {
        selectedDate: reportDate,
        timeUnit,
      },
    });
  };

  const role = data.role || "manager";

  const timeUnit = data.time_unit || "week";
  const startDay = moment(data.report_date);
  const endDay = startDay
    .clone()
    .add(1, timeUnit + "s")
    .add(-1, "days");

  const reportDay = data.report_date;
  const start = startDay.format("MMM DD");
  const end =
    startDay.format("MMM") === endDay.format("MMM")
      ? endDay.format("DD")
      : endDay.format("MMM DD");
  const timeUnitSuf = timeUnit === "day" ? "daily" : timeUnit + "ly";

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 80 }]}>
        {/*  <CloseIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          style={cardStyles.closeButton}
        /> */}

        <View style={[cardStyles.header, { paddingHorizontal: 0 }]}>
          <ReportsIcon width={24} height={24} />

          <View style={styles.row}>
            <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
              <Text style={cardStyles.title}>
                Time to submit your {timeUnitSuf} report
              </Text>
            </View>
            <View style={[cardStyles.headerInfo, { marginLeft: 6 }]}>
              <Text style={cardStyles.date}>
                {start} - {end}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.content}>
          <Text style={styles.textArea}>
            Let your {role} know what went well, what challenges you faced, and
            how they can help.
          </Text>

          <ManaButton
            onPress={() => createReport(reportDay, timeUnit)}
            style={[cardStyles.buttonSmall, { minWidth: 60, height: 30 }]}
            styleText={cardStyles.buttonSmallText}
            text="Start"
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textArea: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    marginRight: 6,
    flex: 1,
  },
});
